import { call, put, takeEvery, takeLatest } from "redux-saga/effects"
import store from "../../index"
// Login Redux States
import { LOGIN_USER, LOGOUT_USER } from "./actionTypes"
import { apiError, loginSuccess, logoutUserSuccess } from "./actions"
//Include Both Helper File with needed methods
import {
  storeTokenToLocalStorage,
  deleteTokenFromLocalStorage,
  storeUserToLocalStorage,
} from "../../../helpers/helpers"
import { logoutApiCall, postLogin } from "../../../helpers/repository"
import { getAllRoles } from "../../roles/actions"
import { showErrorMessages } from "helpers/helpers"

function* loginUser({ payload: { user, history } }) {
  try {
    const response = yield call(postLogin, {
      email: user.email,
      password: user.password,
    })

    let token = response.data._token
    storeTokenToLocalStorage(token)

    storeUserToLocalStorage(response.data)
    yield put(loginSuccess(response.data))
    yield put(apiError(""))
    yield put(getAllRoles())
    history.push("/welcome")
  } catch (error) {
    yield put(apiError(error.response.data))
    // history.push("/login")
  }
}

function* logoutUser({ payload: { history } }) {
  try {
    const response = yield call(logoutApiCall)
    yield put(logoutUserSuccess(response))
  } catch (error) {
    yield put(apiError(error))
  } finally {
    deleteTokenFromLocalStorage()
    localStorage.removeItem("user")
    store.dispatch({
      type: "RESET",
    })
    history.push("/login")
  }
}

function* authSaga() {
  yield takeEvery(LOGIN_USER, loginUser)
  yield takeEvery(LOGOUT_USER, logoutUser)
}

export default authSaga
